import { ModalWrapperComponent } from './../../pages/home/components/modal-wrapper/modal-wrapper.component';
import { ChatBotObject, ComponentType, VisibleChatBotData } from './../../interfaces/home.interface';

import { Component, ComponentRef, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ChatBotData } from 'src/app/interfaces/home.interface';
import { HomeService } from 'src/app/services/home/home.service';
import { ToasterService } from '../toast/toaster.service';
import { ApiErrorMessage } from 'src/app/enums/api-status.enum';
import { timeout } from 'd3';
import { formatDate } from '@angular/common';
import { UserService } from 'src/app/services/user/user.service';
import { MotifModal, ModalSizes } from '@ey-xd/ng-motif';

@Component({
  selector: 'app-ms-chat',
  templateUrl: './ms-chat.component.html',
  styleUrls: ['./ms-chat.component.scss']
})
export class MSChatComponent {
  chatData: ChatBotData = {
    welcomeText: '',
    choices: []
  };
  selectedId: string = '';
  visibleChatData: Array<VisibleChatBotData> = [];
  engagementId: any = "";
  errorMessage: string = '';
  error: boolean = false;
  @ViewChild('scrollContainer')
  private chatContainer!: ElementRef;
  loading: boolean = false;
  @Output() toggleChatbotParent = new EventEmitter<string>();

  constructor(
    private router: Router,
    private homeServiceRef: HomeService,
    private toasterServiceRef: ToasterService,
    private route: ActivatedRoute,
    public userService: UserService,
    private modal: MotifModal
  ) { }

  newMessage: string = '';

  ngOnInit(): void {
    console.log(this.userService.userDetails);
    this.engagementId = this.route.snapshot.paramMap.get('id');
    this.loading = true;
    this.homeServiceRef.getChatBotChoices(this.engagementId).subscribe({
      next: (res: ChatBotData) => {
        this.chatData = res;
        this.loading = false;
        this.showInitialOptions(true);
      },
      error: (err) => {
        this.toasterServiceRef.error(ApiErrorMessage.DEFAULT);
        this.loading = false;
        this.error = true;
        this.errorMessage = ApiErrorMessage.DEFAULT;
      }
    });
  }
  showInitialOptions(onOpenChatWindow: Boolean) {
    const now = new Date();
    const level1: VisibleChatBotData = { 'Level': this.chatData.choices.map(v => ({ ...v, user: false, selectedDate: now.toLocaleDateString(), selectedTime: now.toLocaleString().split(',')[1], initialOptions: true })) };
    this.visibleChatData.push(level1);
    if (!onOpenChatWindow)
    setTimeout(() => {
      this.scrollToElement();
    }, 100);
  }
  scrollToElement(): void {
    this.chatContainer.nativeElement.scroll({
      top: this.chatContainer.nativeElement.scrollHeight,
      left: 0,
      behavior: 'smooth'
    });
  }
  sendMessage(): void {
    if (this.newMessage.trim() !== '') {
      //   this.messages.push({ text: this.newMessage, sender: 'user' });
      this.newMessage = '';
      // Add static bot response here if needed
    }
  }
  selectOrUnselectChoiceById(valToFind: string, toSelect: boolean) {
    // let foundObj:ChatBotObject;
    JSON.stringify(this.chatData.choices, (_, nestedValue) => {
      if (nestedValue && nestedValue['id'] === valToFind) {
        this.selectedId = valToFind;
        if (toSelect) {
          nestedValue.selected = true;
          const now = new Date();
          nestedValue.selectedDate = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');
          nestedValue.selectedTime = now.toLocaleString().split(',')[1];
          nestedValue.user = true;
          this.visibleChatData.push({ Level: [nestedValue] });
          this.visibleChatData.push({ Level: nestedValue.responses.map((v: ChatBotObject) => ({ ...v, selectedDate: now.toLocaleDateString(), selectedTime: now.toLocaleString().split(',')[1] })) });
          setTimeout(() => {
            this.scrollToElement();
          }, 100);

        } else {
          nestedValue.selected = false;
        }

        console.log(nestedValue)
      }
      return nestedValue;
    });
  };
  // findObjectLevel(data: ChatBotObject[], target: ChatBotObject, level: number = 0): number | null {
  //   if(data && data.length){
  //     data.forEach(obj => {
  //     if (obj.id === target.id) {
  //       return level;
  //     }
  //     if (obj.responses.length) {
  //       const result = this.findObjectLevel(obj.responses, target, level + 1);
  //       if (result !== null) {
  //         return result;
  //       }
  //     }
  //   });

  // }
  //   return null;
  // }
  selectChoice(id: string) {
    // this.selectOrUnselectChoiceById( this.selectedId, false);
    this.selectOrUnselectChoiceById(id, true);
  }
  closeChatbot() {
    this.toggleChatbotParent.next('close');
  }
  // navigateToUrl(url: string) {
  //   const updatedUrl = url.replace('<ClientID>', this.engagementId);
  //   window.open(updatedUrl, "_blank");
  // }
  openDetailsModal(url: string){
    //  const compRef = this.fetchDetailComponent(url);
    const modalRef = this.modal.open(ModalWrapperComponent, {
      size: ModalSizes.TAKE_OVER,
      data: { clientId: this.engagementId,  Url: url}
    });
    modalRef.componentInstance.data = { clientId: this.engagementId, Url: url};
    modalRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
  
  navigateToUrl(url: string) {
    this.openDetailsModal(url);
  }
}
